import { useMemo } from 'react';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';
import { dateFormatter } from 'components/shared/DataGrid/utils/valueFormatters/dateFormatter';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';

export const useColumnDefinitions = () => {
  const { t } = useTranslation();
  return useMemo<GridColDef[]>(
    () => [
      {
        field: 'name',
        headerName: t('adminPortal.declarationTypes.name'),
        hideable: false,
        minWidth: 280,
        flex: 1
      },
      {
        field: 'isDefault',
        headerName: t('adminPortal.declarationTypes.isDefault'),
        type: 'boolean',
        hideable: false,
        minWidth: 120,
        renderCell: BooleanCell
      },
      {
        field: 'validFrom',
        headerName: t('adminPortal.declarationTypes.validFrom'),
        type: 'date',
        hideable: false,
        minWidth: 180,
        valueFormatter: dateFormatter
      },
      {
        field: 'validTo',
        headerName: t('adminPortal.declarationTypes.validTo'),
        type: 'date',
        hideable: false,
        minWidth: 180,
        valueFormatter: dateFormatter
      }
    ],
    [t]
  );
};
